// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_41179","inner":"_4a010","icon":"_29cf1","white":"_801c6"};